import type {Question, QuestionCheckInput} from '@cp/model';
import {questionCheckRulesDirect} from '../../api/callable/question';
import {useFunctionWrap} from '../helper/function/useFunctionWrap';

export function useCheckQuestionWithRulesDirect() {
  const {
    fn: checkQuestionWithRulesDirect,
    loading,
    error,
  } = useFunctionWrap(
    async (questionInput: QuestionCheckInput): Promise<Question> =>
      questionCheckRulesDirect({questionInput}) as Promise<Question>,
  );

  return {
    checkQuestionWithRulesDirect,
    loading,
    error,
  };
}
